export const PROPERTIES = {
    LOCKED_LINK_ENTITY: 'LockedLinkEntity',
    TYPES: 'Types'
};